import { useEffect } from "react";

export default function WelderProfileLinkCleanup(){
  useEffect(()=>{
    let queued=false;
    const clean=()=>{
      document.querySelectorAll<HTMLTableCellElement>("table tbody td:first-child").forEach(cell=>{
        const button=[...cell.querySelectorAll<HTMLButtonElement>("button")].find(b=>b.textContent?.trim()==="Open profile");
        if(!button)return;
        button.style.display="none";
        button.setAttribute("aria-hidden","true");
        button.tabIndex=-1;
        cell.classList.remove("welder-profile-cell-clean");
      });
    };
    const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;clean()})};
    const observer=new MutationObserver(schedule);
    observer.observe(document.body,{childList:true,subtree:true});
    schedule();
    return()=>observer.disconnect();
  },[]);
  return null;
}
